import { CommandName, getFragment, } from "../../../../src/ipm/background";
import * as logger from "../../../utilities/background";
import { Timing } from "../timing.types";
import { defaultPriority } from "./ipm-onpage-dialog.types";
function getParamDefinitionList() {
    const { isEmptyOrPositiveNumber, isNotEmpty, isValidDomainList, isSafeUrl, isValidLicenseStateList, } = getFragment();
    return [
        {
            name: "timing",
            validate: (param) => {
                if (typeof param !== "string") {
                    return false;
                }
                return (param === Timing.afterWebAllowlisting ||
                    param === Timing.revisitWebAllowlisted ||
                    param === Timing.afterNavigation ||
                    param === Timing.cookieBanner);
            },
        },
        {
            name: "display_duration",
            validate: (param) => typeof param === "undefined" || (typeof param === "number" && param >= 0 && param <= 20),
        },
        {
            name: "sub_title",
            validate: isNotEmpty,
        },
        {
            name: "upper_body",
            validate: isNotEmpty,
        },
        {
            name: "button_label",
            validate: isNotEmpty,
        },
        {
            name: "button_target",
            validate: isSafeUrl,
        },
        {
            name: "domain_list",
            validate: isValidDomainList,
        },
        {
            name: "license_state_list",
            validate: isValidLicenseStateList,
        },
        {
            name: "priority",
            validate: isEmptyOrPositiveNumber,
        },
        {
            name: "lower_body",
            validate: (param) => typeof param === "undefined" || isNotEmpty(param),
        },
    ];
}
function getBehavior(command) {
    var _a;
    if (!isDialogCommand(command)) {
        return null;
    }
    return {
        displayDuration: typeof command.display_duration === "number" ? command.display_duration : 5,
        target: command.button_target,
        timing: command.timing,
        domainList: command.domain_list,
        licenseStateList: (_a = command.license_state_list) !== null && _a !== void 0 ? _a : getFragment().defaultLicenseState,
        priority: typeof command.priority === "number" ? command.priority : defaultPriority,
    };
}
function getContent(command) {
    if (!isDialogCommand(command)) {
        return null;
    }
    return {
        body: typeof command.lower_body === "string"
            ? [command.upper_body, command.lower_body]
            : [command.upper_body],
        button: command.button_label,
        title: command.sub_title,
    };
}
function isDialogCommand(command) {
    const validationErrors = getFragment().validateParams(command, getParamDefinitionList());
    if (validationErrors.length === 0) {
        return true;
    }
    logger.error("[onpage-dialog]: Invalid parameters received:", validationErrors.join(" "));
    return false;
}
export function setDialogCommandHandler(handler, clearCommands) {
    getFragment().setCommandActor(CommandName.createOnPageDialog, {
        clearCommands,
        getBehavior,
        getContent,
        handleCommand: handler,
        isValidCommand: isDialogCommand,
        onCommandsProcessed: () => { },
    });
}
